export const defaultDrawerWidth = 392;
